/* eslint-disable no-console */

import { Fragment } from 'react'
import Ubah from '@components/button/Ubah'

const action = (hooks) => {
  hooks.visibleColumns.push((columns) => [
    ...columns,
    {
      id: 'status_display',
      Header: () => (<div>Status</div>),
      Cell: ({ row: { original: data } }) => (
        <span style={{ color: data.status ? '#9873B9' : '#EF6C57' }}>
          { data.status ? 'Terhubung' : 'Tidak Terhubung' }
        </span>
      ),
    },
    {
      id: 'action',
      Header: () => (<div>Aksi</div>),
      Cell: ({ row: { original: data } }) => (
        <Fragment>
          <Ubah type="edit" data={data} />
        </Fragment>
      ),
    },
  ])
}

export default action
